import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet } from 'react-helmet';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('mac-for-a-match'));
root.render(
  <>
    <Helmet>
      <script type="text/javascript" src="https://e3a6bda4a543.ap-southeast-2.sdk.awswaf.com/e3a6bda4a543/1a10b59c1701/challenge.js" defer></script>
    </Helmet>
    <App />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
